import { useEffect, useRef, useState } from "react";

const SearchableDropdownMulti = ({
  options,
  label,
  label2,
  label3,
  id,
  other,
  selectedVal,
  handleChange,
  inputProps,
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", toggle);
    return () => document.removeEventListener("click", toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => "");
    const displayValue = [label, label2, label3]
      .filter((l) => l !== "ignore")
      .map((l) => option[l])
      .join(" ");
    handleChange(displayValue, option[id], option[other]);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;
    return "";
  };

  const filter = (options) => {
    return options?.filter((option) => {
      const searchString = [label, label2, label3]
        .filter((l) => l !== "ignore")
        .map((l) => option[l])
        .join(" ");
      return searchString.toLowerCase().indexOf(query?.toLowerCase()) > -1;
    });
  };

  return (
    <div className="dropdown">
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={getDisplayValue()}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value);
              handleChange(null);
            }}
            onClick={toggle}
            autoComplete="off"
            {...inputProps}
          />
        </div>
        <div className={`arrow ${isOpen ? "open" : ""}`}></div>
      </div>

      <div className={`options ${isOpen ? "open" : ""}`}>
        {filter(options)?.map((option, index) => {
          const displayValue = [label, label2, label3]
            .filter((l) => l !== "ignore")
            .map((l) => option[l])
            .join(" ");
          return (
            <div
              onClick={() => selectOption(option)}
              className={`option ${
                displayValue === selectedVal ? "selected" : ""
              }`}
              key={`${id}-${index}`}
            >
              {displayValue}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchableDropdownMulti;
